import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { toggleSearchBar } from "@client/widgets/Header/actions";
import { isSearchVisibleSelector } from "@client/widgets/Header/selectors";
import { type Dispatch } from "react";
import SearchToggle, { type SearchToggleActionProps, type SearchToggleMapProps } from "./component";

const INVISIBLE_PROPS: SearchToggleMapProps & WithIsVisibleHOCProps = {
  isToggled: false,
  isVisible: false
};

const mapStateToProps = (state: AppState): SearchToggleMapProps & WithIsVisibleHOCProps => {
  const { widgets } = state;
  const isVisible = isSearchVisibleSelector(state);
  if (!isVisible) return INVISIBLE_PROPS;

  return {
    isToggled: widgets.header.isSearchBarVisible,
    isVisible: true
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): SearchToggleActionProps => ({
  onToggle: () => dispatch(toggleSearchBar())
});

export default connectCustom(mapStateToProps, mapDispatchToProps)(SearchToggle);
